import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/FoodAndDrink.css';
import OurProductsSection from "./OurProductsSection"
import FoodAndDrinkImg from '../assets/FoodAndBeveragesMain.jpeg';

import food1 from '../assets/food1.jpeg'
import food2 from '../assets/food2.png'
import food3 from '../assets/food3.png'
import food4 from '../assets/food4.png'
import food5 from '../assets/food5.png'
import food6 from '../assets/food6.png'
import food7 from '../assets/food7.png'
import food8 from '../assets/food8.png'
import food9 from '../assets/food9.png'
import food10 from '../assets/food10.png'

import FoodAndDrinkpdf from '../assets/dummy.pdf'

// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';


const FoodAndDrink = () => {
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="FoodAndDrink">
      <Header />

      {/* Hero Banner Section */}
      {/* <section className="hero-banner8">
        <div className="hero-content">
          <h1>FOOD AND DRINK</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Food And Drink</span>
          </div>
        </div>
      </section> */}

<section className="FoodAndDrink-hero-clean">
  <div className="hero-text">
    <h1>Food And Beverages Industry</h1>
    <p>
From hygienic packaging to precise filling and labeling, our smart sensor solutions ensure safety, efficiency, and compliance in food and beverage processes.
</p>
  </div>
  <br/>
  <div className="hero-image">
    <img src={FoodAndDrinkImg} alt="FoodAndDrink Industry" />
  </div>
</section>


<section className="food-drink-content">
  {[
    {
      title: "Storage in tanks",
      subtitle: "Level detection in a tank:",
      text: ` Pressure sensors of the PG, PI or PM series detect the level as well as the system pressure in storage tanks`,
      img: food1
    },
    {
      title: " Valve monitoring",
      subtitle: "Monitoring of rising stem valves:",
      text: ` Efector valvis precisely detects the position of rising stem valves. It signals up to three valve positions: valve open, valve closed and any interim position such as seat lift.`,
      img: food2
    },
    {
      title: "Pump system",
      subtitle: "Pump run-dry protection:",
      text: `  When conveying dairy products the product flow has to be monitored. Flow sensors monitor the flow to avoid dry running of the pump.`,
      img: food3
    },
    {
      title: " Pasteuriser",
      subtitle: "Redundant temperature:",
      text: " Measurement for increased process reliability For the life of the milk it is of high im portance that the correct temperatures are kept. The self-monitoring and  diag nostic functions of TAD-type temperature transmitters ensure that the process runs smoothly",
      img: food4
    },
    {
      title: " Separator",
      subtitle: "Continuous bearing monitoring on a separator:",
      text: " The efector octavis vibration diagnostic unit monitors the bearing of the motor. Maintenance measures can then be precisely planned. This increases plant uptime.",
      img: food5
    },
    {
      title: "Heat exchangers",
      subtitle: "Temperature monitoring on a heat exchanger:",
      text: "  In indirect heating a heat exchanger is used for the heat transmission. For the quality of a product it is decisive that the correct temperature is kept.",
      img: food6
    },
    {
      title: "Homogeniser",
      subtitle: "Pressure monitoring in homogenisers:",
      text: " An important process is the homogeni sation. For a targeted and reproducible process, the pressure conditions in the pump aggregate must be precisely  monitored or regulated.",
      img: food7
    },
    {
      title: "Filling / conveying technology",
      subtitle: "Photoelectric sensor for the detection of bottles:",
      text: "  The photoelectric sensor reliably detects glass and PET bottles on the conveyor of the filling system. All signals can be transferred to the controller via AS-Interface using a cable.",
      img: food8
    },
    {
      title: "CIP / SIP system",
      subtitle: "Pressure monitoring:",
      text: "  For monitoring CIP / SIP systems  offers many different measuring systems such as pressure and temperature sensors or electronic contact manometers.",
      img: food9
    },
    {
      title: "Mixer / mincer",
      subtitle: "Level detection on a mixer / mincer:",
      text: " The meat is chopped in the mincer. It is especially suited to detect the level. It can be adjusted to liquid and viscous media as well as bulk materials via IO-Link.",
      img: food10
    }
  ].map((item, idx) => (
    <div className={`food-row ${idx % 2 !== 0 ? 'reverse' : ''}`} key={idx}>
      <div className="food-image">
        <img src={item.img} alt={item.title} />
      </div>
      <div className="food-text">
        <h3>{item.title}</h3>
        <h4>{item.subtitle}</h4>
        <p>{item.text}</p>
      </div>
    </div>
  ))}
</section>


<OurProductsSection />
      <section className="action-buttons-section">
        <a href={FoodAndDrinkpdf} target="_blank" rel="noopener noreferrer">
          <button className="download-btn">📄 Download</button>
        </a>
          <button className="quote-btn" onClick={() => setIsModalOpen(true)}>📩 Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      </section>

      <Footer />
    </div>
  );
};
export default FoodAndDrink;